var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopiedBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5171 8.87319L12.1558 7.78506L9.28967 10.6506L8.20807 9.19567L7.47656 9.9238L9.17078 12.2029L9.17477 12.2149L9.17761 12.2121L9.90932 11.4841L9.90779 11.482L12.5171 8.87319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03668 3.89341L5.50411 3.33277H15.4645V15.5007L14.9594 16.1066L14.492 16.6672H4.53156V4.49925L5.03668 3.89341Z",
    stroke: "black",
    strokeWidth: 1.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopiedBlack);
export default __webpack_public_path__ + "static/media/copied-black.c51ae09dbab572d816b75962ba29086a.svg";
export { ForwardRef as ReactComponent };